module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-list"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Role:")]), _vm._v(" "), (_vm.hasAdminAdminPermission) ? _c('pl-select', {
    staticClass: "pa0",
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "options": ['student', 'teacher'],
      "selected": _vm.user.role,
      "isLoading": _vm.user.id === _vm.loadingUserId,
      "disabled": _vm.user.id === _vm.loadingUserId,
      "arrow": true
    },
    on: {
      "change": function($event) {
        return _vm.changeUserRole(_vm.user, $event)
      }
    }
  }) : _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.user.role) + " ")])], 1), _vm._v(" "), (_vm.user.user_school) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("School Role:")]), _vm._v(" "), (_vm.canChangePrivileges) ? _c('pl-select', {
    staticClass: "pa0",
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "options": ['student', 'teacher'],
      "selected": _vm.user.user_school[0].role,
      "isLoading": _vm.user.id === _vm.loadingSchoolRoleUserId,
      "disabled": _vm.user.id === _vm.loadingSchoolRoleUserId,
      "arrow": true
    },
    on: {
      "change": function($event) {
        return _vm.changeUserSchoolRole(_vm.user, $event)
      }
    }
  }) : _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.user.user_school[0].role) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Email:")]), _vm._v(" "), _c('div', [_c('span', {
    class: _vm.adminPortalUser ? '' : 'pr2'
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), (_vm.adminPortalUser) ? _c('pl-menu', {
    attrs: {
      "menuSize": 3,
      "direction": "right"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "margin": "0px",
      "padding": "0",
      "min-width": "20px",
      "min-height": "20px",
      "line-height": "20px",
      "font-size": "12px"
    },
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    on: {
      "click": _vm.editUserEmail
    }
  }, [_vm._v("Edit User Email")])])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Account Created:")]), _vm._v(" "), _c('span', {
    staticClass: "pr2"
  }, [_vm._v(_vm._s(_vm.accountCreated))])]), _vm._v(" "), (_vm.isTeacher && _vm.user.profile_url) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Universe Portfolio:")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-link"
  }, [_c('a', {
    staticClass: "flex",
    attrs: {
      "href": _vm.getFullProfileURL(_vm.user.profile_url),
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.user.profile_url) + "\n        "), _c('i', {
    staticClass: "fas fa-external-link-alt",
    on: {
      "click": function($event) {
        return _vm.goToUniverse(_vm.user.profile_url)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.user.user_school) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("School Site:")]), _vm._v(" "), (_vm.canChangePrivileges) ? _c('pl-select', {
    staticClass: "pa0 col-xs-6",
    attrs: {
      "options": _vm.school_sites,
      "selected": _vm.user.schoolSite ? _vm.user.schoolSite.name : 'No Site',
      "isLoading": _vm.user.id === _vm.loadingUserSchoolSiteId,
      "disabled": _vm.user.id === _vm.loadingUserSchoolSiteId,
      "arrow": true
    },
    on: {
      "change": function($event) {
        return _vm.updateUserSchoolSite(_vm.user, $event)
      }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.user.schoolSite ? _vm.user.schoolSite.name : 'No Site') + "\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isTeacher && _vm.user.user_school && _vm.user.user_school[0]) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Admin Privileges:")]), _vm._v(" "), (_vm.canChangePrivileges) ? _c('pl-select', {
    staticClass: "pa0",
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "options": ['coach', 'admin', 'none'],
      "selected": _vm.user.user_school[0].admin_role,
      "isLoading": _vm.user.id === _vm.loadingAdminRoleUserId,
      "disabled": _vm.user.id === _vm.loadingAdminRoleUserId,
      "arrow": true
    },
    on: {
      "change": function($event) {
        return _vm.updateSchoolUserAdminRole(_vm.user, $event)
      }
    }
  }) : _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.user.user_school[0].admin_role) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isTeacher) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Subjects:")]), _vm._v(" "), _c('div', {
    staticClass: "subjects-list pr2"
  }, _vm._l((_vm.user.subjects), function(subject, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n        " + _vm._s(subject.name) + _vm._s(index < _vm.user.subjects.length - 1 ? ',' : '') + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isTeacher) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Grade Levels:")]), _vm._v(" "), _c('div', {
    staticClass: "grades-list pr2"
  }, _vm._l((_vm.user.grade_levels), function(grade, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n        " + _vm._s(grade.grade) + "\n        " + _vm._s(index < _vm.user.grade_levels.length - 1 ? ', ' : '') + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.adminPortalUser) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Active Passes")]), _vm._v(" "), _c('div', {
    staticClass: "tr pa0"
  }, [_c('div', [_vm._v("\n        Current Unused passes: " + _vm._s(_vm.user_membership_details.activity_passes) + "\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passes_to_create),
      expression: "passes_to_create"
    }],
    staticClass: "passes-create-input",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.passes_to_create)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passes_to_create = $event.target.value
      }
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "margin-right": "0px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createActivityPasses.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Create More\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.adminPortalUser) ? _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("Active Memberships")]), _vm._v(" "), _c('div', {
    staticClass: "f7"
  }, [_vm._l((_vm.active_memberships), function(membership) {
    return _c('div', {
      key: membership.id,
      staticClass: "mt2"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(":\n        " + _vm._s(membership.end_date_readable) + "\n        "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n        "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership Type")]), _vm._v(": " + _vm._s(membership.membership.type) + "\n      ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticStyle: {
      "margin-right": "0px"
    },
    attrs: {
      "type": "date",
      "id": "start",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "end"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "fr",
    staticStyle: {
      "margin-right": "0px"
    },
    attrs: {
      "type": "date",
      "id": "end",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('pl-button', {
    staticClass: "pl-primary fr",
    staticStyle: {
      "margin-right": "0px"
    },
    attrs: {
      "disabled": Boolean(!(_vm.start_date && _vm.end_date))
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewUserMembership.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Create New\n          ")])], 1)])], 2)]) : _vm._e(), _vm._v(" "), (_vm.adminPortalUser && _vm.show_edit_user_email_modal) ? _c('edit-user-email-modal', {
    attrs: {
      "user": _vm.user
    },
    on: {
      "close": function($event) {
        _vm.show_edit_user_email_modal = false
      },
      "update-user-email": _vm.updateUserEmail
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-141a5a27!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/userDetailsModal/detailsTabContent.vue
// module id = 2043
// module chunks = 61